<template>
  <main>
    <sqr-error :error="invoiceLoadError" @retry="created()" />
    <section class="section" v-if="invoice">
      <div class="container">
        <sqr-hero
          :title-raw="$t('invoice_issuer_title', invoice)"
          subtitle="invoice_issuer_subtitle"
          color="primary"
          is-bold
          :is-loading="invoiceLoading"
        />
        <div class="box is-radiusless">
          <div
            class="columns"
            v-if="
              issuer && invoice.issuer && issuer._rev !== invoice.issuer._rev
            "
          >
            <div class="column is-4-desktop">
              <article class="message is-warning">
                <div class="message-body">
                  <div class="content">
                    <p>{{ $t('invoice_issuer_sync_help') }}</p>
                  </div>
                  <p>
                    <sqr-button
                      label="invoice_issuer_sync"
                      color="warning"
                      @click="sync()"
                    />
                  </p>
                </div>
              </article>
            </div>
          </div>

          <practice-form
            :practice="invoice.issuer"
            @change="proxyFieldSet"
            :validations="$v.invoice.issuer"
          />

          <div class="sticky-bottom">
            <div class="field">
              <div class="buttons is-pulled-right">
                <sqr-button
                  label="buttons_back"
                  to-name="welcome"
                  size="large"
                  color="light"
                  @click="$router.back()"
                />
                <sqr-button
                  label="buttons_change"
                  color="primary"
                  size="large"
                  @click="saveAndGo()"
                  :is-loading="invoiceSaving || issuerSaving"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import { validationMixin } from 'vuelidate';

import PracticeForm from '../forms/PracticeForm';

import practice from '../filters/practice';
import practiceVal from '../validations/practice';

export default {
  name: 'InvoiceIssuer',
  mixins: [validationMixin],
  components: { PracticeForm },
  computed: {
    ...mapGetters('account', ['account', 'accountId']),
    ...mapGetters('invoice', {
      invoiceLoading: 'loading',
      invoiceLoadError: 'loadError',
      invoice: 'invoice',
      invoiceSaving: 'saving'
    }),
    issuer() {
      if (
        this.account &&
        this.account.issuers &&
        this.invoice &&
        this.invoice.issuerId &&
        this.invoice.issuerId !== 'embeded'
      ) {
        return this.account.issuers[this.invoice.issuerId];
      } else {
        return null;
      }
    }
  },
  validations() {
    return {
      invoice: {
        issuer: practiceVal
      }
    };
  },
  async mounted() {
    this.$a().logEvent('invoice_issuer');
    await this.invoiceSubscribe({ id: this.$route.params.id });
  },
  methods: {
    ...mapMutations('invoice', {
      invoiceFieldSet: 'fieldSet'
    }),
    ...mapActions('invoice', {
      invoiceSubscribe: 'subscribe',
      invoiceSave: 'save'
    }),
    ...mapActions('issuer', {
      issuerSave: 'save'
    }),

    proxyFieldSet(payload) {
      this.invoiceFieldSet({ group: 'issuer', ...payload });
    },

    sync() {
      this.invoiceFieldSet({
        data: {
          issuerId: this.issuer._id,
          issuer: this.issuer
        }
      });
    },

    async saveAndGo() {
      if (this.$v.$invalid) return this.$v.$touch();
      this.proxyFieldSet({
        field: 'name',
        value: practice(this.invoice.issuer)
      });
      const accountId = this.accountId;
      await this.invoiceSave({ accountId });
      this.$router.back();
    }
  }
};
</script>
